<template>
  <div class="customer-list">
    <div class="tab-box">
      <div class="item" :class="{active: currentCmp== 'countMoneyWinning'}" @click="changeTab('countMoneyWinning')">中奖信息</div>
      <div class="item" :class="{active: currentCmp == 'countMoneyPrize'}" @click="changeTab('countMoneyPrize')">奖品信息</div>
    </div>
    <mescroll-vue
      ref="mescroll"
      :down="mescrollDown"
      :up="mescrollUp"
      class="scroll"
      @init="mescrollInit"
    >
      <div id="content">
        <component :is="currentCmp" :list="list" />
      </div>
    </mescroll-vue>
  </div>
</template>

<script>
import MescrollVue from 'mescroll.js/mescroll.vue'
import countMoneyWinning from './components/countMoney-winning.vue';
import countMoneyPrize from './components/countMoney-prize.vue';
import noDataImg from "@/assets/images/img-default@2x.png";
export default {
  components: {
    MescrollVue,
    countMoneyWinning,
    countMoneyPrize,
  },
  computed: {
    activityId() {
      return this.$route.query.activityId
    }
  },
  data() {
    return {
      mescroll: null,
      mescrollDown: {
        callback: this.init
      },
      mescrollUp: {
        callback: this.getList,
        page: {
          num: 1,
          size: 10
        },
        htmlNodata: '<p class="upwarp-nodata">-- 没有更多数据了 --</p>',
        noMoreSize: 1,
        auto: true,
        empty: {
        // 列表第一页无任何数据时,显示的空提示布局; 需配置warpId才生效;
        warpId: 'content', // 父布局的id;
        icon: noDataImg, // 图标,支持网络图
        tip: '暂无数据', // 提示
      },
      },
      activeName: "1",
      list: [],
      currentCmp: 'countMoneyWinning',
    };
  },
  methods: {
    changeTab(cmp) {
      this.currentCmp = cmp
      this.init()
    },
    init() {
      this.list = []
      // 下拉刷新的回调; 默认重置上拉加载列表为第一页
      this.mescroll.resetUpScroll()
    },
    mescrollInit(mescroll) {
      this.mescroll = mescroll
    },
    getList(page, mescroll) {
      const params = this.$route.query
      const requestMesthod = this.currentCmp == 'countMoneyWinning' ? 'getActivityCountMoneyRecord' : 'getCountMoneyActivityAwards' 
      this.$api.countMoney[requestMesthod]({
        filterData: {...params},
        pageNum: page.num,
        pageSize: page.size,
      })
        .then(({data}) => {
          if (data.list) {
            this.list.push(...data.list);
            this.pageNum = data.pageNum + 1;
            mescroll.endSuccess(this.list.length, data.hasNextPage)
          }
        })
    },
  },
  filters: {
  }
};
</script>
<style lang="stylus" scoped>
.customer-list {
  .tab-box {
    display: flex;
    background: #fff;
    .item {
      flex: 1;
      font-size: #999999;
      text-align: center;
      line-height: 44px;
      font-size: 14px;
      height: 44px;
    }
    .active {
      color: #FF6B31;
      background: #FFF2ED;
    }
  }
}
</style>
